import React, { useEffect, useState, useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useUnidades } from "../../../hooks/test/useUnidades";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SelectFontawesome } from "../../General/SelectFontawesome";
import { toast } from "react-toastify";
import {
    faSave,
} from "@fortawesome/free-solid-svg-icons";
const initialStateFormEstatus = {
    nombre: "",
    id_tipo_movimiento: "",
    icon: "",

};

// Array con las opciones para el tipo de movimiento
const tipoMovimiento = [
    {
        id_tipo_movimiento: 1,
        tipo: "EXITOSO",
    },
    {
        id_tipo_movimiento: 2,
        tipo: "ADVERTENCIA",
    },
    {
        id_tipo_movimiento: 3,
        tipo: "ALERTA",
    },
    {
        id_tipo_movimiento: 4,
        tipo: "INFORMACION",
    },
    {
        id_tipo_movimiento: 5,
        tipo: "COMPLETADO",
    },
    {
        id_tipo_movimiento: 6,
        tipo: "CANCELADO",
    },
];

export const AddEdo = ({ show, handleClose, title, children, onEdoSaved }) => {
    const {
        postEstatus,
    } = useUnidades();
    // Estados locales del componente
    const [form, setForm] = useState(initialStateFormEstatus);
    const [loading, setLoading] = useState(false);

    const reset = () => {
        setForm(initialStateFormEstatus);
    };

    const handleCerrarModal = () => {
        reset();
        handleClose();
    };

    const resetSaved = async () => {
        reset();
        if (onEdoSaved) {
            onEdoSaved();
        }
    };

    const handleChangeIcon = (icon) => {
        let iconDraw = form.icon !== icon ? icon : "";
        setForm({ ...form, icon: iconDraw });
    };

    const save = async (event) => {
        event.preventDefault();
        setLoading(true);
        const flag = validaciones();
        if (!flag) {
            return null;
        }
        // console.log("Datos del formulario que se enviarán:", form); // <-- LOG AÑADIDO
        let resp = await postEstatus(form);
        setLoading(false);
        handleClose();
        if (resp.ok) {
            Swal.fire({
                title: "Estatus creado correctamente",
                icon: "success",
                timer: 3000,
                showConfirmButton: false,
            });
            resetSaved();
        }
        else {

            Swal.fire({
                title: "Lo siento",
                text: resp.msg,
                icon: "info",
            });
        }
        return resetSaved();
    }

    const handleChange = async (event) => {
        let value = event.target.value;
        const name = event.target.name;

        if (name === "nombre") { // Aplicar mayúsculas solo al campo 'nombre' (Nombre del Estatus)
            value = event.target.value.toUpperCase(); // Convertir el valor a mayúsculas
        }

        setForm({
            ...form,
            [name]: value,
        });
        // console.log("handleChange - form.nombre:", form.nombre); // <-- LOG AÑADIDO

    };


    const validaciones = () => {
        if (!form.id_tipo_movimiento) showToastError("Favor de seleccionar Tipo de Movimiento");
        if (!form.nombre)
            showToastError("Favor de insertar el nombre delEstatus");
        if (!form.icon) showToastError("Favor de seleccionar el Icono")
        if (!form.nombre || !form.id_tipo_movimiento || !form.icon) return false;
        return true;
    };

    const showToastError = (msj = "Ha ocurrido un error") => {
        toast.error(msj, {
            position: "bottom-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    // 4. JSX: Estructura del modal usando componentes de React Bootstrap
    // console.log("Render AddEdo - form.nombre:", form.nombre); // <-- LOG AÑADIDO
    return (
        <Modal show={show}
            onHide={handleCerrarModal}
            backdrop="static"
            keyboard={true}
            size="xl">
            <form className="form-card" onSubmit={save}>
                <Modal.Header closeButton>
                    <Modal.Title >{<strong>REGISTRO DE NUEVO ESTATUS </strong>}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className='row'>
                            <div className='col-md-6 flex-column d-flex'>
                                {/*Icono del estatus */}
                                <label className=' form-label'>Seleccione el icono del estatus*:</label>
                                <SelectFontawesome
                                    value={form.icon}
                                    onChange={handleChangeIcon}
                                ></SelectFontawesome>

                            </div>
                            <div className=' col-md-6'>
                                <div className='form-group col-sm mt-3 mb-5 flex-column d-flex'>
                                    {/*Descripcion del Estatus*/}
                                    <label className='form-label'>Nombre de Estatus*</label>
                                    <input
                                        className='form-control'
                                        value={form.nombre}
                                        id='nombre'
                                        name="nombre"
                                        onChange={handleChange}

                                    >
                                    </input>
                                </div>
                                <div className='form-group col-sm mt-3 mb-3 flex-column d-flex'>
                                    {/*Seleccion del Movimiento */}
                                    <label className='mb-2'>Tipo de Movimiento*</label>
                                    <select
                                        className="form-control"
                                        name="selectMovimiento"
                                        value={form.id_tipo_movimiento}
                                        onChange={(event) => {
                                            setForm({
                                                ...form,
                                                id_tipo_movimiento: event.target.value,
                                            });
                                        }}
                                    >
                                        <option value={""}>Seleccione una Opción</option>
                                        {tipoMovimiento.map((x) => (
                                            <option key={x.id_tipo_movimiento} value={x.id_tipo_movimiento}>
                                                {x.tipo}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="submit"
                        className="btn btn-AzulTotalProtect text-white cursor"
                    >
                        <FontAwesomeIcon icon={faSave} />
                        &nbsp; {"Crear Estatus"}
                    </button>
                    &nbsp;
                </Modal.Footer>
            </form>
        </Modal>
    );
};
